import { useState } from "react";
import { Apis } from "../../lib/Apis";

export const useContractCategory = () => {
  const [loading, setLoading] = useState(false);

  const addContractCategory = async (categoryData) => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("title", categoryData.title);
      if (categoryData.description) {
        formData.append("description", categoryData.description);
      }
      if (categoryData.custom_url) {
        formData.append("custom_url", categoryData.custom_url);
      }

      if (categoryData.image instanceof File) {
        formData.append("image", categoryData.image);
      }

      const response = await Apis.addContractCategory(formData);
      if (response?.status === 201) {
        return response.data;
      } else {
        throw new Error(response?.data?.error || response?.data?.message || "Failed to add category.");
      }
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || "Error adding category.");
    } finally {
      setLoading(false);
    }
  };

  const editContractCategory = async (id, categoryData) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("title", categoryData.title);
      if (categoryData.description !== undefined) {
        formData.append("description", categoryData.description);
      }
      if (categoryData.custom_url) {
        formData.append("custom_url", categoryData.custom_url);
      }

      if (categoryData.image instanceof File) {
        formData.append("image", categoryData.image);
      }

      const response = await Apis.updateContractCategory(id, formData);
      if (response?.status === 200) {
        return response.data;
      } else {
        throw new Error(response?.data?.error || response?.data?.message || "Failed to edit category.");
      }
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message || "Error editing category.");
    } finally {
      setLoading(false);
    }
  };

  const getContractCategories = async (setCategories, setTotal, offset = 0, limit = 10, search = "") => {
    setLoading(true);
    try {
      const params = {};
      if (search) {
        params.search = search;
      }

      const response = await Apis.getContractCategories(offset, limit, params);

      if (response?.status === 200) {
        setCategories(response.data.data);
        setTotal(response.data.pagination?.totalRecords || response.data.data.length);
        return response;
      } else {
        throw new Error(response?.data?.message || "Failed to fetch categories.");
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      throw new Error(error.message || "Error fetching categories.");
    } finally {
      setLoading(false);
    }
  };

  const deleteContractCategory = async (id) => {
    try {
      setLoading(true);
      const response = await Apis.deleteContractCategory(id);
      return response.data;
    } catch (error) {
      throw new Error(error.message || "Error deleting category.");
    } finally {
      setLoading(false);
    }
  };

  return {
    addContractCategory,
    editContractCategory,
    loading,
    getContractCategories,
    deleteContractCategory
  };
};
